/** @jsx jsx */
import { jsx, CSSObject } from '@emotion/react'
import React, { useEffect, useRef, useState } from 'react';
import VideoPreview from 'components/VideoPreview/VideoPreview';
import { useData } from '../Data';
import { personHref } from 'components/langutils';
import styled from '@emotion/styled';

const StaffConferenceBase = styled('div')((): CSSObject => ({
  position: 'static',
  display: 'flex',
  top: -1,
  left: 0,
  right: 0,
  background: 'var(--iti-bg)',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflow: 'inherit',
  alignContent: 'center',
  justifyContent: 'center',
  alignItems: 'flex-start',
  '&.isSticky': {
    paddingTop: '6px',
    paddingBottom: '8px',
    paddingLeft: '12px',
    paddingRight: '12px',
    position: 'fixed',
    // below the header and the breadcrumb, which stay at the top as well (see iti.css)
    top: 'var(--iti-sticky-bottom, 0px)',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    zIndex: 1000,
    boxShadow: 'var(--iti-shadow)',
  },
}));

export function StaffConference() {
  const { users, hover, setHover, lang } = useData();
  const ref = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // The pictures become a strip below the header and the breadcrumb once all of them have
    // scrolled out under these, and go back to their place when that comes into view again.
    const onScroll = () => {
      const strip = ref.current, place = ref2.current;
      if(!strip || !place) {
        return;
      }
      const bar = document.querySelector('.site-breadcrumb') ?? document.querySelector('.site-header');
      const top = bar?.getBoundingClientRect().bottom ?? 0;
      const bottom = place.getBoundingClientRect().bottom;
      if(!strip.classList.contains('isSticky')) {
        if(bottom < top) {
          place.style.height = `${place.getBoundingClientRect().height}px`;
          strip.classList.add('isSticky');
        }
      } else if(bottom > top + strip.getBoundingClientRect().height) {
        strip.classList.remove('isSticky');
        place.style.height = '';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <div ref={ref2} style={{position: 'relative'}}>
    <StaffConferenceBase className="StaffConference" ref={ref}>
      {users.filter((u:any)=>u.active).map((user: any) => <div key={user.login} style={{ margin: '2px' }}>
        <a href={personHref(user, lang)} onMouseEnter={() => setHover(user.login)} onMouseLeave={() => setHover(user.login)}>
          <VideoPreview loopEnd={user.videoLoopEnd} src={user.video} img={user.image} name={`${user.first_name} ${user.last_name}`} width="120px" height="80px" hover={hover === user.login} />
        </a>
      </div>
      )}
    </StaffConferenceBase>

    </div>
  );
}
